import AdvancedArticle from 'mk2/apps/blogs/containers/AdvancedArticle/AdvancedArticle';
import ArticlePage, {
    DispatchProps as ArticleDispatchProps,
    OwnProps,
    RouteProps,
    StateProps,
} from 'mk2/apps/blogs/containers/Article/ArticlePage';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';

interface DispatchProps extends ArticleDispatchProps {
}

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class AdvancedArticlePage extends ArticlePage {

    public render(props: Props): false | JSX.Element {
        return <AdvancedArticle {...props} />;
    }

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {
                ...(super.mapStateToProps()(state, ownProps) as StateProps),
            };
        };
    }
}
